import React from 'react';

const TestComponent = () => {
  return (
    <div className="p-8 bg-background-secondary dark:bg-background min-h-screen">
      <div className="max-w-4xl mx-auto space-y-8">
        {/* Header */}
        <div className="text-center">
          <h1 className="text-4xl font-bold text-foreground mb-4">
            🎨 Tailwind CSS Test
          </h1>
          <p className="text-muted-foreground">
            Testing our new design system components
          </p>
        </div>

        {/* Color Palette */}
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Color Palette</h2>
            <p className="card-description">Our new color system</p>
          </div>
          <div className="card-content">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="p-4 rounded-lg bg-primary-500 text-white text-center">
                Primary
              </div>
              <div className="p-4 rounded-lg bg-success-500 text-white text-center">
                Success
              </div>
              <div className="p-4 rounded-lg bg-warning-500 text-white text-center">
                Warning
              </div>
              <div className="p-4 rounded-lg bg-danger-500 text-white text-center">
                Danger
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Buttons</h2>
            <p className="card-description">Button variants</p>
          </div>
          <div className="card-content">
            <div className="flex flex-wrap gap-4">
              <button className="btn-primary">Primary Button</button>
              <button className="btn-secondary">Secondary Button</button>
              <button className="btn-success">Success Button</button>
              <button className="btn-warning">Warning Button</button>
              <button className="btn-danger">Danger Button</button>
              <button className="btn-outline">Outline Button</button>
              <button className="btn-ghost">Ghost Button</button>
            </div>
          </div>
        </div>

        {/* Gradients */}
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Gradients</h2>
            <p className="card-description">Beautiful gradient backgrounds</p>
          </div>
          <div className="card-content">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="gradient-primary p-6 rounded-lg text-white text-center">
                Primary Gradient
              </div>
              <div className="gradient-success p-6 rounded-lg text-white text-center">
                Success Gradient
              </div>
              <div className="gradient-warning p-6 rounded-lg text-white text-center">
                Warning Gradient
              </div>
              <div className="gradient-danger p-6 rounded-lg text-white text-center">
                Danger Gradient
              </div>
            </div>
          </div>
        </div>

        {/* Badges */}
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Badges</h2>
            <p className="card-description">Status indicators</p>
          </div>
          <div className="card-content">
            <div className="flex flex-wrap gap-4">
              <span className="badge-primary">Primary</span>
              <span className="badge-secondary">Secondary</span>
              <span className="badge-success">Success</span>
              <span className="badge-warning">Warning</span>
              <span className="badge-danger">Danger</span>
              <span className="badge-outline">Outline</span>
            </div>
          </div>
        </div>

        {/* Status Indicators */}
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Status Indicators</h2>
            <p className="card-description">Status badges</p>
          </div>
          <div className="card-content">
            <div className="flex flex-wrap gap-4">
              <span className="status-delivered">Delivered</span>
              <span className="status-processing">Processing</span>
              <span className="status-pending">Pending</span>
              <span className="status-cancelled">Cancelled</span>
            </div>
          </div>
        </div>

        {/* Animations */}
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Animations</h2>
            <p className="card-description">Smooth animations</p>
          </div>
          <div className="card-content">
            <div className="flex flex-wrap gap-4">
              <div className="w-16 h-16 gradient-primary rounded-lg flex items-center justify-center text-white animate-pulse-soft">
                Pulse
              </div>
              <div className="w-16 h-16 gradient-success rounded-lg flex items-center justify-center text-white animate-fade-in">
                Fade In
              </div>
              <div className="w-16 h-16 gradient-warning rounded-lg flex items-center justify-center text-white animate-slide-up">
                Slide Up
              </div>
              <div className="w-16 h-16 gradient-danger rounded-lg flex items-center justify-center text-white animate-scale-in">
                Scale In
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestComponent; 